import type { Locale } from 'antd/es/locale';
import locale from 'antd/es/locale/pl_PL';
import { mergeDeepRight } from 'ramda';

// NOTE: Ant design translations for PL lang are incomplete so
// feel free to add translations for what you are missing or want to customize.
// Default translations can be found here: node_modules\antd\lib\locale\default.js

export const plPL: Locale = mergeDeepRight(locale, {
  Form: {
    defaultValidateMessages: {
      required: 'Wprowadź ${label}', // 'Please enter ${label}'
      types: {
        email: 'E-mail jest nieprawidłowy',
        number: '${label} musi być liczbą', // '${label} is not a valid number',
        integer: '${label} musi być liczbą całkowitą',
      },
      number: {
        min: '${label} musi być co najmniej ${min}', // '${label} must be minimum ${min}'
        max: '${label} nie może być większa niż ${max}', // '${label} must be maximum ${max}'
        range: '${label} musi być między ${min} a ${max}', // '${label} must be between ${min} and ${max}'
      },
    },
  },
  Pagination: {
    items_per_page: 'zapisów',
  },
  DatePicker: {
    lang: {
      // NOTE: Ant does not offer other way to customize translations in DatePicker, long names are according to design
      shortMonths: [
        'Styczeń',
        'Luty',
        'Marzec',
        'Kwiecień',
        'Maj',
        'Czerwiec',
        'Lipiec',
        'Sierpień',
        'Wrzesień',
        'Październik',
        'Listopad',
        'Grudzień',
      ],
      shortWeekDays: ['nd', 'pn', 'wt', 'śr', 'cz', 'pt', 'so'],
    },
  },
} as Partial<Locale>) as Locale;
